import { Card } from 'src/app/components/Elements/Card';
import { Typography } from 'src/app/components/Elements/Typography';
import { CAPSULE_ICON_STRINGS } from 'src/consts';

import { CardBody, CardContent, CloseIconWrapper } from './styles';

const NotEligibleCard = () => {
  return (
    <Card style={'red'}>
      <CardContent>
        <CloseIconWrapper iconString={CAPSULE_ICON_STRINGS.close_circle} block raw />
        <CardBody>
          <Typography variant={'overline'} color={'capsuleRed10'}>
            PATIENT IS NOT ELIGIBLE. TRY ANOTHER ZIP
          </Typography>
        </CardBody>
      </CardContent>
    </Card>
  );
};

export default NotEligibleCard;
